<ng-template #modalTemplate>
	<div *ngIf="render">
		<div class="modal-header">
			<h4 class="modal-title pull-left">{{title}}</h4>
			<button type="button" class="close pull-right" aria-label="Close" (click)="onHide()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<ng-content></ng-content>
		</div>
		<div class="modal-footer" *ngIf="hasConfirmButton || hasCloseButton">
			<button *ngIf="hasConfirmButton" type="button" class="btn {{confirmBtnClass}}" (click)="onConfirm()">{{confirmBtnText}}</button>
			<button *ngIf="hasExtraBtn" type="button" class="btn {{confirmBtnClass}}" (click)="onExtraBtnClicked()">{{extraBtnText}}</button>
			<button *ngIf="hasCloseButton" type="button" class="btn btn-default" (click)="onHide()">{{closeBtnText}}</button>
		</div>
	</div>
</ng-template>